var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.83471 0.438773C9.15494 0.455621 9.4681 0.639826 9.63401 0.994084L11.5628 5.13407L15.8781 5.79697C16.652 5.91579 16.9621 6.92577 16.4009 7.50424L13.2789 10.7249L14.0173 15.2745C14.1502 16.0906 13.3379 16.7129 12.6468 16.3283L8.81051 14.1967L4.97425 16.3283C4.28309 16.7129 3.47082 16.0906 3.60374 15.2745L4.34216 10.7249L1.22012 7.50424C0.658915 6.92577 0.969052 5.91579 1.74292 5.79697L6.05825 5.13407L7.98701 0.994084C8.15292 0.639826 8.46608 0.455621 8.7863 0.438773V0.4375C8.79437 0.4375 8.80244 0.437606 8.81051 0.437818C8.81858 0.437606 8.82665 0.4375 8.83471 0.4375V0.438773Z",
    fill: "#114559"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/Union.fbc69854880f8009d35359e951f2c5b1.svg";
export { ForwardRef as ReactComponent };